import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { mergeMap, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppState } from '../../app.state';
import {
  Route,
  RoutingHelperService,
} from '../services/routing-helper.service';

export const contractGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router)
  const routingService = inject(RoutingHelperService);
  const routes = Route;

  return store.select(AppState.getPlan).pipe(
    mergeMap((plan) => {
      if (plan.hasContract) {
        return of(true);
      }

      router.navigate([routingService.getRelativePath(routes.Plans.path)]);
      return of(false);
    }),
    catchError(() => {
      router.navigate([routingService.getRelativePath(routes.Plans.path)]);
      return of(false);
    })
  );
};
